import type { IProductCard } from '@klv/molecules/product-card/types';
import type { IProductsCardFullWidth } from '@klv/molecules/products-card-full-width/types';
import type {  TCardOverrides } from '../types';

export const getCardOverrides = (overrides: TCardOverrides, cards: IProductCard[]) => {
  const customCardData: IProductCard[] = [];

  cards.map((card: IProductCard) => {
    if (card.buttonText === 'Email marketing' && overrides?.emailMarketingButtonUrl) {
      customCardData.push({ ...card, buttonUrl: overrides?.emailMarketingButtonUrl });
    } else  if (card.buttonText === 'SMS marketing' && overrides?.smsMarketingButtonUrl) {
      customCardData.push({ ...card, buttonUrl: overrides?.smsMarketingButtonUrl });
    } else if (card.buttonText === 'Mobile push' && overrides?.mobilePushButtonUrl) {
      customCardData.push({ ...card, buttonUrl: overrides?.mobilePushButtonUrl });
    } else  if (card.buttonText === 'Reviews' && overrides?.reviewsButtonUrl) {
      customCardData.push({ ...card, buttonUrl: overrides?.reviewsButtonUrl });
    } else {
      customCardData.push(card);
    }
  });
  return customCardData;
};

export const getCDPCardOverrides = (overrides: TCardOverrides, card: IProductsCardFullWidth) => {
  const customCardData = card;

  if (overrides?.customerDataPlatformButtonUrl) {

    customCardData.buttonUrl = overrides?.customerDataPlatformButtonUrl;
  }
  return customCardData;
};
